<template>
    <div class="page-bg">
      <div class="title-box">
        <search-head :searchValue="searchValue" @focusSearch="focusSearch" @searchValue="searchBackValue"></search-head>
      </div>
      <div class="search-history-content">
        <div class="history-header" v-if="goodsList.length === 0">
          <span class="history-title">搜索历史</span>
          <img @click="deleteHistory" class="icon" src="../../assets/images/icon/icon-delete.png" alt="" />
        </div>
        <div class="labels" v-if="goodsList.length === 0">
          <van-tag v-for="item in historySearch" :key="item" @click="tagClick(item)" class="label" round type="primary" size="large" color="#FFFFFF" text-color="#516773">{{ item }}</van-tag>
        </div>
        <div v-if="goodsList.length === 0 && searchValue !== ''" class="no-result">
          <img src="../../assets/images/empty/no-search-result.png" alt="" />
          <span class="no-result-text">请搜索有效商品型号、名称</span>
        </div>
        <div v-else>
          <goods-show :goodsList="goodsList"></goods-show>
        </div>
      </div>
    </div>
</template>

<script>
  import searchHead from './components/searchHead'
  import goodsShow from './components/goodsShow'
  import axios from 'axios'
  import apiConfig from '@/api'
    export default {
      name: 'retail-search',
      props: {
      },
      data () {
        return {
          searchValue: '',
          historySearch: [],
          goodsList: [],
        }
      },
      components:{
        searchHead,
        goodsShow
      },
      created(){
        this.searchValue = sessionStorage.getItem("searchValue") || '';
        this.historySearch = JSON.parse(localStorage.getItem("historySearch")) || [];
      },
      methods:{
        deleteHistory() {
          this.$dialog.confirm({
            title: '注意',
            width: '80%',
            className: 'van-dialog__message',
            message: '您确认要清空搜索历史记录么？',
            getContainer: '.title-box'
          })
            .then(() => {
              this.searchValue = '';
              this.historySearch = [];
              sessionStorage.setItem("searchValue", this.searchValue);
              localStorage.setItem("historySearch", JSON.stringify(this.historySearch));
            })
            .catch(() => {
              // on cancel
            });
        },
        searchBackValue(data) {
          if (data) {
            this.searchValue = data;
            this.historySearch.push(data);
            this.historySearch = this.historySearch.filter((item, index) => this.historySearch.indexOf(item) === index);
            sessionStorage.setItem("searchValue", this.searchValue);
            localStorage.setItem("historySearch", JSON.stringify(this.historySearch));
          }
          this.searchProducts(data);
          
        },
        tagClick(data) {
          this.searchValue = data;
          sessionStorage.setItem("searchValue", this.searchValue);
          this.searchProducts(data);
        },
        focusSearch() {
          this.goodsList = [];
        },
        searchProducts(value) {
          const url = apiConfig.serverAddress + apiConfig.searchProduct;
          const restParams = {
            pageNo: 1,
            pageSize: 999,
            searchName: value,
            needImgHttps: 1,
          }
          const headers = {
            'Content-Type': "application/json",
            __TokenAuthorization_UserName_:'admin',
            __TokenAuthorization_Function_:'refreshClassificationLevelAndSort'
          }
          axios  //axios请求体BODY上为model
          .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
          .then(res => {
            this.goodsList = res.data.data;
          });
        },
      }
    }
</script>

<style scoped>
  .page-bg {
    background: #FFFFFF;
    height: 100%;
  }
  .title-box {
    position: relative;
  }
  .search-history-content {
    flex-grow: 1;
    padding: 32px;
  }
  .history-header {
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #666666;
    letter-spacing: 0;
    line-height: 42px;
    font-weight: 400;
  }
  .icon {
    width: 45px;
    height: 45px;
  }
  .history-title {
    font-size: 35px;
  }
  .labels {
    display: flex;
    flex-wrap: wrap;
  }

  .label {
    margin-right: 16px;
    background: #ffffff;
    border-radius: 5px;
    padding: 12px 24px;
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #333333;
    letter-spacing: 0;
    line-height: 36px;
    font-weight: 400;
  }
  .title-box >>> .van-button--default {
    font-size: 40px;
  }
  .no-result {
    width: 100%;
    text-align: center;
  }
  .no-result img {
    width: 360px;
    height: 280px;
    margin-top: 200px;
  }
  .no-result  .no-result-text {
    display: block;
    margin-top: 36px;
    font-size: 28px;
    color: rgba(0, 0, 0, 45%);
  }
</style>
<style>
  .van-dialog__message {
    font-size: 35px !important;
    line-height: 50px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/retail/search.vue